import Vue from "vue"
import SelfExplanationComponent from "./SelfExplanation.vue"
import i18n from "@/locale/index"

let instanceQueue = []
const defaultOptions = {
  code: "",
  goToFun: null,
  goBackFun: null
}

function parseOptions(options) {
  if (typeof options === "string" || typeof options === "number") {
    return { code: options }
  }
  return options
}

function createInstance() {
  const Constructor = Vue.extend(SelfExplanationComponent)
  const instance = new Constructor({ i18n })

  instance.$mount()
  document.body.appendChild(instance.$el)

  instance.$on("close", () => {
    const index = instanceQueue.indexOf(instance)
    if (index !== -1) {
      instanceQueue.splice(index, 1)
    }
    instance.$destroy()
    if (instance.$el && instance.$el.parentNode) {
      instance.$el.parentNode.removeChild(instance.$el)
    }
  })

  return instance
}

function SelfExplanation(options = {}) {
  const parsedOptions = { ...defaultOptions, ...parseOptions(options) }

  // 单例模式：清除旧实例
  if (instanceQueue.length > 0) {
    instanceQueue.forEach(inst => inst.clear())
    instanceQueue = []
  }

  const instance = createInstance()

  instance.code = parsedOptions.code
  instance.goToFun = parsedOptions.goToFun
  instance.goBackFun = parsedOptions.goBackFun
  instanceQueue.push(instance)

  Vue.nextTick(() => {
    instance.show()
  })

  return instance
}

// 手动清除所有
SelfExplanation.clear = () => {
  instanceQueue.forEach(instance => instance.clear())
  instanceQueue = []
}

// Vue 插件安装
SelfExplanation.install = function () {
  Vue.prototype.$selfExplanation = SelfExplanation
}

export default SelfExplanation



// WEBPACK FOOTER //
// ./src/components/commons/SelfExplanation/index.js